// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__VdMkt","dark":"layout_dark__osqsy","content":"layout_content__A5wLR","backgroundCanvas":"layout_backgroundCanvas__cALR5"};